<template>
  <section>
    <div class="container wfs--main">
      <div class="row">
          <div class="col-md-12 bread">
              <ol class="bread-crumb breadcrumb-fill0">
                  <li><router-link to="/home">home</router-link></li>
                  <li><a href="javascript:void(0);" class="bread-text ">NovaSenha</a></li>
              </ol>
          </div>
          
          <!--Login nova senha-->
          <card class="col-md-12">
              <div class="row">
                  <div class="col-md-12" v-if="msgAlterada" style="padding-right: 13px;">
                      <div
                      class="card"
                      style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
                      v-if="msg==1"
                      >
                      <div class="card-body">
                          <div class="row">
                          <div class="col-md-12">{{msgAlterada}}</div>
                          </div>
                      </div>
                      </div>
                      <div
                      class="card"
                      style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
                      v-if="msg==0"
                      >
                      <div class="card-body">
                          <div class="row">
                          <div class="col-md-12">{{msgAlterada}}</div>
                          </div>
                      </div>
                      </div>
                      <div
                      class="card"
                      style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
                      v-if="msg==2"
                      >
                      <div class="card-body">
                          <div class="row">
                          <div class="col-md-12">{{msgAlterada}}</div>
                          </div>
                      </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-6" >
                      <form>
                          <h4 slot="header" class="card-title" style='margin-bottom: 15px;'>Trocar Senha do Login </h4>
                          <p>Olá <b>{{nome}}</b>, abaixo você poderar alterar a senha de <b>{{email}}</b></p>
                          <div class="form-group">
                              <label for="senha">SENHA:</label>
                              <input type="password" class="form-control"
                                placeholder="Digite a nova senha"
                                id="senha"
                                v-on:blur="validacaoSenha(login.senha)"
                                v-model="login.senha"
                                :style="styleSenha"
                                >
                              <div v-if="senhaverify==0">
                                  <label
                                      class="control-label"
                                      v-if="styleSenha!=''"
                                      style="color:rgb(243 0 0);font-size: 12px;"
                                  >*Obrigatorio</label>
                              </div>
                              <label
                                class="control-label"
                                v-if="senhaverify==1"
                                style="color:rgb(183 179 55);font-size: 12px;"
                              >
                                    * minimo 6 caracteres
                              <br />* minimo 1 letra
                              <br />* minimo 1 numero
                              <!--<br />* minimo 1 caractere especial ex: &!#$ -->
                              </label>
                          </div>
                          <div class="form-group">
                              <label for="senha">VERIFICAR SENHA:</label>
                              <input type="password" class="form-control" 
                                  placeholder="Digite novamente a senha"
                                  id="senhaverify" 
                                  v-model="login.senhaVerificar"
                                  v-on:blur="validacaoSenhaVerify(login.senha,login.senhaVerificar)"
                                  :style="styleSenhaVerify">
                          </div>
                          <div class="text-center">
                            <button
                              type="submit"
                              class="btn btn-primary btn-fill float-left"
                              @click.prevent="alterarSenha"
                            >Alterar</button>
                          </div>
                      </form>
                  </div>
                  <div class="col-md-6" >
                      <img src="/img/ilust-protecao.png" style='width: 100%;'>
                  </div>
              </div>
          </card> 
      </div> 
    </div>
  </section>            
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import 'src/controller/usuarioAlteracaoController.js';
import "src/controller/site/cidadaoController.js";

export default {
  components: {
    Card,
  },
  props: {
    token: {
      require: true,
    },
    nome: {
      require:true,
    },
    email: {
      require:true,
    }
  },
  data() {
    return {
        login:{
          senha:null,
          senhaVerificar:null,
        },
        msgAlterada: null,
        styleSenha:"",
        styleSenhaVerify:"",
        senhaverify: 0,
    };
  },

  methods: {
    async alterarSenha(){
      try {
        this.validacaoSenha(this.login.senha);
        let data = await this.$novaSenha(this.login.senha,this.token);
        if(data){
          this.msgAlterada =
              "Senha foi alterada!";
          this.msg = 1;
          this.$confirm("Ir a pagina de login?").then(() => {
             this.loginRota();
          });
          
        }
      } catch (e) {
        this.msgAlterada = e.response.data.error;
        this.msg = 0;
      }
    },
    loginRota(){
      try {
        this.$router.push({name: 'loginCidadao'} );
      } catch (e) {
        
      }
    },
    validacaoSenhaVerify(senha,senhaVerificar){
      this.styleSenhaVerify="";  
      if(senhaVerificar){
         if(senha == senhaVerificar){
            this.styleSenhaVerify ="border: 2px solid rgb(64, 185, 124);";
            this.SenhaVerify = 1;
         }else{
            this.styleSenhaVerify ="";
            this.SenhaVerify = 0;
         }
      }
    },
    validacaoSenha(senha) {
      
      if (senha) {
        this.styleSenha = "";
        this.msgAlterada = "";
        this.senhaverify = 0;

        if (senha.length <= 3) {
          this.msgAlterada =
            "O campo Senha tem que ter no minimo 4 Caracteres!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[a-z]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo uma letra!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[0-9]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo um numero!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        /*if (senha.search(/[!@#$%^&*]/i) < 0) {
          this.msgAlterada =
            "O campo Senha deve possuir no minimo um caracter especial!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }*/

        this.senhaverify = 0;
        this.verify_senha = true;
      } else {
        this.styleSenha = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Senha está Vazio!";
        this.msg = 0;
        this.senhaverify = 0;
        this.verify_senha = false;
        return false;
      }
    }
  },
  beforeMount() {
    //console.log(this.dados_recebidos);
  }, 
}
</script>
<style scoped>
 .card{
    border: 0px solid rgba(0, 0, 0, 0.125) !important;
 }
</style>